// extracted by mini-css-extract-plugin
export default {"state":"StateView_state__MO-1N","title":"StateView_title__eRzO1","text":"StateView_text__iFRiD","errorIcon":"StateView_errorIcon__STZCM","emptyIcon":"StateView_emptyIcon__eOndV"};